/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const UserAccessStatus = {
    Invited: 'INVITED',
    Active: 'ACTIVE',
    Suspended: 'SUSPENDED'
} as const;
export type UserAccessStatus = typeof UserAccessStatus[keyof typeof UserAccessStatus];

